import React  from 'react';
import TileContent from './TileContent';
import TileFooter from './TileFooter';
import TileHeader from './TileHeader';
import classes from './CheckTile.module.scss';
import cn from 'classnames';
import { safeJsonParse } from '../../../../utility/helperFunction';

const CheckTile = props => {
  const {
    section,
    check,
    showPopup,
    onFooterButtonPress,
    onTileClicked,
    selectedCheck,
    currentMode,
  } = props;
  const isSelected = check?.id === selectedCheck;
  const deviceGroup = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {})?.deviceGroup;
  const isVenueMode = deviceGroup?.startMode === 6 || false;

  return (
    <div
      className={cn(classes.cardContainer, isSelected && classes.selecteditem)}
      onClick={() => onTileClicked(check.id)}
    >
      {/* <div className={cn(classes.tileContainer, isSelected && classes.selectedTile)} onClick={() => onTileClicked(check.id)}> */}
      <TileHeader
        check={check}
        showPopup={showPopup}
        currentMode={currentMode}
      />
      <TileContent check={check} mode={currentMode} isVenue={isVenueMode} />
      <TileFooter
        section={section}
        check={check}
        onFooterButtonPress={onFooterButtonPress}
        currentMode={currentMode}
      />
    </div>
  );
};

export default CheckTile;
